import { isNil, isString, isNotNil } from '@flowio/is'; // https://github.com/Microsoft/TypeScript/issues/27024#issuecomment-421529650

function resolveContainer(config) {
  var container = null;

  if (isString(config.container)) {
    container = document.querySelector(config.container);
  } else if (!isNil(config.container)) {
    container = config.container;
  }

  return !isNil(container) ? container : document.body;
}

export default function createFrame(config) {
  var name = config.name,
      source = config.source,
      style = config.style;
  var frame = document.createElement('iframe');
  var container = resolveContainer(config); // TODO: Provide interface to customize all possible HTMLIFrameElement
  // attributes instead.

  frame.frameBorder = '0';
  frame.name = name;
  frame.src = source; // Give iframe permission to access the Payment Request API.
  // Note that, Permission Policy replaces the `allowpaymentrequest` attribute,
  // however it is still considered an experimental feature.

  frame.allow = 'payment *';
  frame.allowPaymentRequest = true;

  if (isNotNil(style)) {
    Object.keys(style).forEach(function (key) {
      var prop = key;
      var value = style[prop];

      if (isNotNil(value)) {
        frame.style[prop] = value;
      }
    });
  }

  container.appendChild(frame);
  return frame;
}


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/postmessage/lib/esm/createFrame.js
// module id = 649
// module chunks = 0 1